import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class InterceptTokenService implements HttpInterceptor {

  constructor(private a: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.includes("spotify.com") && !request.url.includes("/login") && !request.url.includes("/register")) { //added for assignment if not include spotify
      // Clone the existing request, and add the authorization header
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.a.getToken()}`,
        },
      });

    }
    // Pass the request on to the next handler
    return next.handle(request);
  }
}
